const FONT_SIZE = {
	tiny: '1.2rem',
	small: '1.6rem',
	medium: '2.4rem',
	large: '2.4rem',
	big: '2.6rem',
	huge: '4.8rem',
}

const FONT_WEIGHT = {
	thin: '100',
	light: '300',
	regular: '500',
	bold: '700',
	extraBold: '900',
}

const theme = {
	FONT_SIZE,
	FONT_WEIGHT,
}

export default theme
